module.exports = __webpack_public_path__ + "img/logo-ng.f5bead9e.png";